export default __webpack_public_path__ + "static/media/logo-optimized.4a7404d0.png";